import React, { useState } from 'react';
import leafImage from '../assets/leaf.png';

// Custom styles for FAQ component
const styles = `
.faq-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 80px 0;
}

/* Decorative circle - Top Right */
.faq-circle-top-right {
    position: absolute;
    top: -80px;
    right: -80px;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay - Top Right */
.faq-leaf-top-right {
    position: absolute;
    top: -60px;
    right: -60px;
    width: 240px;
    height: 240px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

/* Decorative circle - Bottom Left */
.faq-circle-bottom-left {
    position: absolute;
    bottom: 20px;
    left: -120px;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlay - Bottom Left */
.faq-leaf-bottom-left {
    position: absolute;
    bottom: 40px;
    left: -100px;
    width: 260px;
    height: 260px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

.faq-content-wrapper {
    position: relative;
    z-index: 3;
}

/* Main Heading */
.faq-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.8rem;
    font-weight: 800;
    color: #5A3411;
    text-align: center;
    margin-bottom: 40px;
}

/* FAQ Grid */
.faq-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

/* FAQ Item */
.faq-item {
    background-color: #F5F1E9;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.faq-question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 25px;
    cursor: pointer;
    gap: 15px;
}

.faq-question-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.05rem;
    font-weight: 600;
    color: rgba(90, 52, 17, 0.85);
    line-height: 1.5;
    margin: 0;
    flex: 1;
}

.faq-icon {
    width: 24px;
    height: 24px;
    min-width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
}

.faq-icon svg {
    width: 18px;
    height: 18px;
    stroke: rgba(90, 52, 17, 0.7);
    stroke-width: 2.5;
    fill: none;
}

.faq-item.active .faq-icon {
    transform: rotate(180deg);
}

/* FAQ Answer */
.faq-answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
}

.faq-item.active .faq-answer {
    max-height: 500px;
}

.faq-answer-content {
    padding: 0 25px 20px 25px;
}

.faq-answer-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 0.95rem;
    font-weight: 500;
    color: rgba(90, 52, 17, 0.75);
    line-height: 1.7;
    margin: 0;
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .faq-section {
        padding: 70px 0;
    }
    
    .faq-heading {
        font-size: 2.5rem;
        margin-bottom: 35px;
    }
    
    .faq-grid {
        gap: 18px;
    }
    
    .faq-question-text {
        font-size: 1rem;
    }
    
    .faq-circle-top-right {
        width: 220px;
        height: 220px;
        top: -70px;
        right: -70px;
    }
    
    .faq-leaf-top-right {
        width: 190px;
        height: 190px;
        top: -50px;
        right: -50px;
    }
    
    .faq-circle-bottom-left {
        width: 250px;
        height: 250px;
        left: -100px;
    }
    
    .faq-leaf-bottom-left {
        width: 220px;
        height: 220px;
        left: -80px;
    }
}

@media (max-width: 991.98px) {
    .faq-section {
        padding: 60px 0;
    }
    
    .faq-heading {
        font-size: 2.2rem;
        margin-bottom: 30px;
    }
    
    .faq-grid {
        gap: 15px;
    }
    
    .faq-question {
        padding: 18px 22px;
    }
    
    .faq-question-text {
        font-size: 0.95rem;
    }
    
    .faq-circle-top-right {
        width: 180px;
        height: 180px;
        top: -60px;
        right: -60px;
    }
    
    .faq-leaf-top-right {
        width: 150px;
        height: 150px;
        top: -40px;
        right: -40px;
    }
    
    .faq-circle-bottom-left {
        width: 200px;
        height: 200px;
        left: -90px;
    }
    
    .faq-leaf-bottom-left {
        width: 170px;
        height: 170px;
        left: -70px;
    }
}

@media (max-width: 767.98px) {
    .faq-section {
        padding: 50px 0;
    }
    
    .faq-heading {
        font-size: 1.8rem;
        margin-bottom: 25px;
    }
    
    .faq-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }
    
    .faq-question {
        padding: 16px 20px;
    }
    
    .faq-question-text {
        font-size: 0.95rem;
    }
    
    .faq-answer-content {
        padding: 0 20px 18px 20px;
    }
    
    .faq-answer-text {
        font-size: 0.9rem;
    }
    
    .faq-circle-top-right {
        width: 140px;
        height: 140px;
        top: -50px;
        right: -50px;
    }
    
    .faq-leaf-top-right {
        width: 120px;
        height: 120px;
        top: -35px;
        right: -35px;
    }
    
    .faq-circle-bottom-left {
        width: 160px;
        height: 160px;
        left: -70px;
    }
    
    .faq-leaf-bottom-left {
        width: 140px;
        height: 140px;
        left: -55px;
    }
    
    .faq-item {
        border-radius: 10px;
    }
}

@media (max-width: 575.98px) {
    .faq-section {
        padding: 40px 0;
    }
    
    .faq-heading {
        font-size: 1.5rem;
        margin-bottom: 22px;
    }
    
    .faq-grid {
        gap: 10px;
    }
    
    .faq-question {
        padding: 14px 18px;
        gap: 12px;
    }
    
    .faq-question-text {
        font-size: 0.9rem;
    }
    
    .faq-icon {
        width: 20px;
        height: 20px;
        min-width: 20px;
    }
    
    .faq-icon svg {
        width: 14px;
        height: 14px;
    }
    
    .faq-answer-content {
        padding: 0 18px 15px 18px;
    }
    
    .faq-answer-text {
        font-size: 0.85rem;
        line-height: 1.6;
    }
    
    .faq-circle-top-right {
        width: 110px;
        height: 110px;
        top: -40px;
        right: -40px;
    }
    
    .faq-leaf-top-right {
        width: 95px;
        height: 95px;
        top: -28px;
        right: -28px;
    }
    
    .faq-circle-bottom-left {
        width: 130px;
        height: 130px;
        left: -60px;
    }
    
    .faq-leaf-bottom-left {
        width: 110px;
        height: 110px;
        left: -48px;
    }
}

@media (max-width: 400px) {
    .faq-section {
        padding: 35px 0;
    }
    
    .faq-heading {
        font-size: 1.3rem;
        margin-bottom: 20px;
    }
    
    .faq-question {
        padding: 12px 15px;
    }
    
    .faq-question-text {
        font-size: 0.85rem;
    }
    
    .faq-answer-content {
        padding: 0 15px 12px 15px;
    }
    
    .faq-answer-text {
        font-size: 0.8rem;
    }
    
    .faq-circle-top-right {
        width: 90px;
        height: 90px;
        top: -35px;
        right: -35px;
    }
    
    .faq-leaf-top-right {
        width: 75px;
        height: 75px;
        top: -22px;
        right: -22px;
    }
    
    .faq-circle-bottom-left {
        width: 100px;
        height: 100px;
        left: -45px;
    }
    
    .faq-leaf-bottom-left {
        width: 85px;
        height: 85px;
        left: -35px;
    }
    
    .faq-item {
        border-radius: 8px;
    }
}
`;

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        {
            question: "1. What ages do you accept?",
            answer: "We welcome children from 3 months to 5 years old. Our nursery is divided into age-appropriate rooms including Baby Room, Toddler Room, and Preschool to ensure each child receives care tailored to their developmental stage."
        },
        {
            question: "2. Is there a notice period if I decide to leave?",
            answer: "Yes, we require one month's written notice if you wish to withdraw your child from the nursery. This allows us to adjust staffing and offer the place to families on our waiting list."
        },
        {
            question: "3. Will I be charged if my child is on holiday?",
            answer: "Yes, fees are payable for all booked sessions regardless of attendance, including holidays and sickness. This is because we still maintain staffing levels and your child's place during their absence."
        },
        {
            question: "4. Do you offer government funding?",
            answer: "Yes, we accept government funding for eligible 2, 3, and 4-year-olds. This includes the 15 hours and 30 hours free childcare schemes. Please speak to our management team to check your eligibility and discuss how to apply."
        },
        {
            question: "5. Do you support children with SEN?",
            answer: "Absolutely. We are committed to inclusive practice and welcome children with Special Educational Needs (SEN). Our team works closely with parents and external professionals to create personalised support plans ensuring every child thrives."
        },
        {
            question: "6. Do you have CCTV? Can I view it or request a copy?",
            answer: "Yes, we have CCTV throughout the nursery for safeguarding purposes. Footage is stored securely and can only be accessed by management. Requests to view footage must be made in writing and will be considered in line with our data protection policy."
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <>
            <style>{styles}</style>
            <section className="faq-section">
                {/* Decorative Circle - Top Right */}
                <div className="faq-circle-top-right"></div>
                {/* Decorative Leaf - Top Right */}
                <div
                    className="faq-leaf-top-right"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>
                {/* Decorative Circle - Bottom Left */}
                <div className="faq-circle-bottom-left"></div>
                {/* Decorative Leaf - Bottom Left */}
                <div
                    className="faq-leaf-bottom-left"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>

                <div className="container">
                    <div className="faq-content-wrapper">
                        {/* Main Heading */}
                        <h2 className="faq-heading">Frequently Asked Question</h2>

                        {/* FAQ Grid */}
                        <div className="faq-grid">
                            {faqData.map((faq, index) => (
                                <div
                                    key={index}
                                    className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                                >
                                    <div
                                        className="faq-question"
                                        onClick={() => toggleFAQ(index)}
                                    >
                                        <p className="faq-question-text">{faq.question}</p>
                                        <div className="faq-icon">
                                            <svg viewBox="0 0 24 24">
                                                <polyline points="6,9 12,15 18,9"></polyline>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="faq-answer">
                                        <div className="faq-answer-content">
                                            <p className="faq-answer-text">{faq.answer}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FAQ;
